<template>
  <div class="clearfix" v-if="!loader">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="loader" class="card mb-25 border-0 rounded-0 bg-white letter-spacing" id="back">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10"
    >
      <div class="d-sm-flex flex-wrap align-items-center w-100 w-lg-30">
        <button
          class="default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          style="background-color: #EB9355;"
          @click="showScreen('excel')"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
          v-if="current_permissions('export_transactions')"
        >
          {{ $t('transactions.export') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          type="button"
          class="default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          data-bs-toggle="modal"
          data-bs-target="#generateLink"
          v-if="current_permissions('create_public_token')"
        >
          {{ $t('transactions.link') }}<span v-if="environment=='PROD'">{{ $t('transactions.payment') }}</span><span v-if="environment=='DEMO'">{{ $t('transactions.collection') }}</span>
        </button>
      </div>
      <div class="d-sm-flex align-items-center">
        <div>
          <div class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0">
            <input
              v-model="today"
              type="date"
              class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              id="lead-calendar"
              :placeholder="leadPlaceholder"
              @change="searchTransaction1"
            />
          </div>
        </div>
        <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
          @click="showScreen('search')"
          v-if="current_permissions('get_public_checkout')"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table id="" class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('transactions.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.phone') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.amount') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.date') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('transactions.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transaction) in transactions" :key="transaction.checkoutId">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="form-check mb-0">
                    <span class="badge text-outline-primary">
                      <i class="flaticon-web" v-if="transaction.publicToken!=null" style="font-weight: bold;"></i>
                    </span>
                  </div>
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ transaction.checkoutId}}
                  </div>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.operator.mnoName}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.contact}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.amount.toLocaleString()}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDateFr(new Date(transaction.transactionDate))}}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="transaction.paymentStatus==='SUCCEEDED'">{{ $t('transactions.success') }}</span>
                <span class="badge text-outline-danger" v-if="transaction.paymentStatus==='FAILED'">{{ $t('transactions.failed') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='PROCESSING'">{{ $t('transactions.processing') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='PENDING'">{{ $t('transactions.pending') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button
                  class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                  type="button"
                  @click="toggleActionMenu($event, transaction.checkoutId)"
                >
                  <i class="flaticon-dots"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div id="transactionsTable">
          <p>
            <span id="headerLeftText" class="d-lg-inline-block p-2 text-start">{{ organization_name }} </span>
            <span id="headerRightText" class="d-inline-block p-2 text-end redcolor">{{ $t('transactions.editionDate') }} </span>
            <span id="headerRightText" class="d-inline-block p-2 text-end redcolor" style="margin-top: -2%; font-weight:1000;">{{ formatDateFr(new Date()) }} </span>
            <span id="headerLeftText" class="d-lg-inline-block p-2 text-start" style="margin-top: -2%;">{{ email }} </span>
          </p>
          <hr />
          <div style="margin-top: 7%;">
            <h2 class="shadow-none lh-1 fw-medium" id="title" style="">
              <span id="title1">{{ $t('transactions.listTitle') }}</span>
              <span class="text-end" id="title2">{{ $t('transactions.period') }} <span class="date">{{ formatDateFr(new Date(beginDate)) }}</span> {{ $t('transactions.to') }} <span class="date">{{ formatDateFr(new Date(endDate)) }}</span></span>
            </h2>
          </div>
          <hr />
          <div style="padding-left: 1%;padding-right: 1%;" class="">
            <table id="tableLayout" class="table" style="margin-right: 1%;">
              <thead id="t-thead-pdf" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
                <tr>
                  <th style="" class="tableHeader">{{ $t('transactions.code') }}</th>
                  <th class="tableHeader">{{ $t('transactions.operator') }}</th>
                  <th class="tableHeader">{{ $t('transactions.description') }}</th>
                  <th class="tableHeader">{{ $t('transactions.phone') }}</th>
                  <th scope="col" class="tableHeader">{{ $t('transactions.amount') }}</th>
                  <th scope="col" class="tableHeader">{{ $t('transactions.date') }}</th>
                  <th scope="col" class="tableHeader1" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;">{{ $t('transactions.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction1) in transaction1s" :key="transaction1.checkoutId">
                  <td class="fw-medium">
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                        {{ transaction1.checkoutId}}
                      </div>
                    </div>
                  </td>
                  <td class="fw-medium">
                    <span>{{ transaction1.operator.mnoName}}</span>
                  </td>
                  <td class="fw-medium">
                    <span>{{ transaction1.description }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium">{{ transaction1.contact}}</td>
                  <td class="shadow-none lh-1 fw-medium"><span>{{ transaction1.amount.toLocaleString()}}</span></td>
                  <td class="shadow-none lh-1 fw-medium">{{ formatDateFr(new Date(transaction1.transactionDate))}}</td>
                  <td class="shadow-none lh-1 fw-medium">
                    <span v-if="transaction1.paymentStatus==='FAILED'">{{ $t('transactions.failed') }} <img src="../../../assets/images/echec.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.paymentStatus==='SUCCEEDED'">{{ $t('transactions.success') }} <img src="../../../assets/images/success.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.paymentStatus==='PROCESSING'">{{ $t('transactions.processing') }} <img src="../../../assets/images/pending.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.paymentStatus==='PENDING'">{{ $t('transactions.pending') }} <img src="../../../assets/images/pending.svg" alt="logo-icon" style="max-width:25%;"/></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="total>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="total>10" class="mb-0 text-paragraph">
          {{ $t('transactions.showing') }} <span class="fw-bold">{{ page*10 }}</span> {{ $t('transactions.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('transactions.results') }}
        </p>
        <p v-if="total<=10" class="mb-0 text-paragraph">
          {{ $t('transactions.showing') }} <span class="fw-bold">{{ total }}</span> {{ $t('transactions.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('transactions.results') }}
        </p>
        <nav v-if="gettran==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="getTransactions(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="getTransactions(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="getTransactions(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
        <nav v-if="search==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="searchTransaction(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="searchTransaction(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="searchTransaction(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
        <nav v-if="search1==true" class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="searchTransaction1($event,page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="searchTransaction1($event,numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="searchTransaction1($event,page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <ul
      v-if="openMenuId"
      class="dropdown-menu show action-menu-fixed"
      :style="{ top: menuPosition.top + 'px', left: menuPosition.left + 'px' }"
      @click.stop
    >
      <li>
        <a @click="handleView(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          {{ $t('transactions.view') }}
        </a>
      </li>
      <li>
        <a @click="handleReceipt(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          {{ $t('transactions.receipt') }}
        </a>
      </li>
      <li v-if="isSuperAdmin">
        <a @click="handleShowStatus(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
          Statut réel
        </a>
      </li>
      <li>
        <a target="_blank" class="dropdown-item d-flex align-items-center" href="https://wa.me/message/SV5FPBLDUDCBJ1" @click="closeActionMenu">
          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
          {{ $t('transactions.claim') }}
        </a>
      </li>
      <li v-if="isSuperAdmin">
        <a @click="handleChangeStatus(openMenuId)" href="javascript:void(0);" class="dropdown-item d-flex align-items-center">
          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
          Changer statut
        </a>
      </li>
    </ul>
  </Teleport>

  <!-- Modal Filter -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header">
          <h1 v-if="screenSelected=='search'" class="modal-title fs-5">{{ $t('transactions.advancedSearch') }}</h1>
          <h1 v-if="screenSelected=='excel'" class="modal-title fs-5">{{ $t('transactions.exportExcel') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- ═══ Onglets : Critères de base / Filtres avancés ═══ -->
        <div class="modal-tabs">
          <button
            type="button"
            class="modal-tab"
            :class="{ active: activeFilterTab === 'base' }"
            @click="activeFilterTab = 'base'"
          >
            Critères de recherche
            <span class="tab-badge" v-if="activeBaseFiltersCount > 0">{{ activeBaseFiltersCount }}</span>
          </button>
          <button
            type="button"
            class="modal-tab"
            :class="{ active: activeFilterTab === 'advanced' }"
            @click="activeFilterTab = 'advanced'"
            v-if="isPrivilegedRole"
          >
            Filtres avancés
            <span class="tab-badge" v-if="activeAdvancedFiltersCount > 0">{{ activeAdvancedFiltersCount }}</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="errors!==''" style="margin-top: 5%;">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>

          <!-- ═══ Onglet 1 : Critères de recherche ═══ -->
          <div v-show="activeFilterTab === 'base'">
            <div class="row g-3">
              <div class="col-12 col-md-3" v-if="current_permissions('SUPERADMIN')">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.clients') }}</label>
                <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" @change="handleOrganizationChange" required>
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option v-for="organization in organizations" :value="organization.code" :key="organization.id"> {{ organization.name }}</option>
                </select>
              </div>

              <div class="col-12 col-md-3" v-if="current_permissions('SUPERADMIN-ADMIN-USER')">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.country') }}</label>
                <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" @change="handleCountryChange" required>
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="SN">{{ $t('transactions.senegal') }}</option>
                  <option value="CI">{{ $t('transactions.ivoryCoast') }}</option>
                </select>
              </div>

              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operators') }}</label>
                <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleOperatorChange" required>
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option v-for="operator in operators" :value="operator.id" :key="operator.code"> {{ operator.mnoName }}</option>
                </select>
              </div>

              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.statuses') }}</label>
                <select name="status" id="status" class="form-select fs-md-15 text-black shadow-none" @change="handleStatusChange" required>
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="SUCCEEDED">{{ $t('transactions.success') }}</option>
                  <option value="PROCESSING">{{ $t('transactions.processing') }}</option>
                  <option value="PENDING">{{ $t('transactions.pending') }}</option>
                  <option value="FAILED">{{ $t('transactions.failed') }}</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.startDate') }}</label>
                <div>
                  <input v-model="beginDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="leadPlaceholder" />
                </div>
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.endDate') }}</label>
                <div>
                  <input v-model="endDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="leadPlaceholder" />
                </div>
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.category') }}</label>
                <select name="business" id="business" class="form-select fs-md-15 text-black shadow-none" @change="handleBusinessChange" required>
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option v-for="businessItem in business" :value="businessItem.code" :key="businessItem.code"> {{ businessItem.name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-3" id="container_sub_business">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.subCategory') }}</label>
                <select name="sub_business1" id="sub_business1" class="form-select fs-md-15 text-black shadow-none sub_business" @change="handleSubBusinessChange">
                  <option value="">{{ $t('transactions.selectSubCategory') }}</option>
                  <option v-for="subBusinessItem in subBusiness" :value="subBusinessItem.code" :key="subBusinessItem.code"> {{ subBusinessItem.name }}</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.phoneNumber') }}</label>
                <div>
                  <input @keyup="validate_phone_number($event.target.value,$event.target)" v-model="phone_number" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
                </div>
              </div>
            </div>
          </div>

          <!-- ═══ Onglet 2 : Filtres avancés ═══ -->
          <div v-show="activeFilterTab === 'advanced'" v-if="isPrivilegedRole">
            <div class="row g-3">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Code</label>
                <input v-model="filterCode" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">(Checkout ID)</label>
                <input v-model="filterCheckoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Payout ID</label>
                <input v-model="filterPayoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Référence client</label>
                <input v-model="filterClientReference" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">ID client</label>
                <input v-model="filterClientId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Description</label>
                <input v-model="filterDescription" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Token public</label>
                <input v-model="filterPublicToken" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">État</label>
                <input v-model="filterState" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Utilisateur (code)</label>
                <input v-model="filterUser" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Montant exact</label>
                <input v-model="filterAmount" type="number" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Montant min</label>
                <input v-model="filterMinAmount" type="number" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Montant max</label>
                <input v-model="filterMaxAmount" type="number" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">ID Bulk interne</label>
                <input v-model="filterIntBulkId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">ID Bulk opérateur</label>
                <input v-model="filterIntOperatorBulkId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Bulk ID</label>
                <input v-model="filterBulkId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" />
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Type d'opération</label>
                <select name="filterOperationType" id="filterOperationType" class="form-select fs-md-15 text-black shadow-none" @change="handleFilterOperationTypeChange">
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="1">{{ $t('transactions.payin') }}</option>
                  <option value="2">{{ $t('transactions.payout') }}</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Date de transaction</label>
                <div>
                  <input v-model="filterTransactionDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar-transactionDate" :placeholder="leadPlaceholder" />
                </div>
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Type de payout</label>
                <select name="filterPayoutType" id="filterPayoutType" class="form-select fs-md-15 text-black shadow-none" @change="handleFilterPayoutTypeChange">
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="1">Single</option>
                  <option value="2">Bulk</option>
                </select>
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Statut de validation</label>
                <select name="filterValidationStatus" id="filterValidationStatus" class="form-select fs-md-15 text-black shadow-none" @change="handleFilterValidationStatusChange">
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="DRAFT">DRAFT</option>
                  <option value="VALIDATED">VALIDATED</option>
                  <option value="REJECTED">REJECTED</option>
                </select>
              </div>
              <div class="col-12 col-md-3">
                <label class="d-block text-black fw-semibold mb-10">Statut validation TP</label>
                <select name="filterPublicTokenValidationStatus" id="filterPublicTokenValidationStatus" class="form-select fs-md-15 text-black shadow-none" @change="handleFilterPublicTokenValidationStatusChange">
                  <option value="">{{ $t('transactions.select') }}</option>
                  <option value="DRAFT">DRAFT</option>
                  <option value="VALIDATED">VALIDATED</option>
                  <option value="REJECTED">REJECTED</option>
                </select>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="resetAdvancedFilters">
            Réinitialiser les filtres
          </button>
          <button v-if="screenSelected=='search'" type="button" class="btn" style="background-color: #EB9355;" data-bs-dismiss="modal" @click="searchTransaction(1)">
            <i class="flaticon-search-interface-symbol" style="color: #FFF;"></i>
          </button>
          <button v-if="screenSelected=='excel'" :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="searchTransactionForExport()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('transactions.excel') }}</span>
          </button>
          <button v-if="screenSelected=='excel'" :disabled="!btnLoad1" type="button" class="btn" style="background-color:blue;" @click="exportToPDF()">
            <span v-if="!btnLoad1" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('transactions.pdf') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Details -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('transactions.transactionDetails') }} ({{ paymentStatus }})</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- ═══ Onglets : Infos principales / Infos avancées ═══ -->
          <div class="modal-tabs">
            <button
              type="button"
              class="modal-tab"
              :class="{ active: activeDetailTab === 'main' }"
              @click="activeDetailTab = 'main'"
            >
              Informations principales
            </button>
            <button
              type="button"
              class="modal-tab"
              :class="{ active: activeDetailTab === 'advanced' }"
              @click="activeDetailTab = 'advanced'"
              v-if="isPrivilegedRole"
            >
              Informations avancées
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">

              <!-- ═══ Onglet 1 : Informations principales ═══ -->
              <div v-show="activeDetailTab === 'main'">
                <div class="row g-3">
                  <div class="col-12 col-md-3" v-if="hasValue(transaction.checkoutId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.transactionCode') }}</label>
                    <input v-model="transaction.checkoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3"
                       v-if="transaction.paymentStatus==='SUCCEEDED' && hasValue(transaction.operator?.mnoName==='WAVE' ? transaction.providerTransactionId : transaction.providerTransactionReference)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operatorReference') }}</label>
                    <input v-if="transaction.operator?.mnoName!=='WAVE'" v-model="transaction.providerTransactionReference" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                    <input v-if="transaction.operator?.mnoName=='WAVE'" v-model="transaction.providerTransactionId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(amount)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.amount') }}</label>
                    <input v-model="amount" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.transactionDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.date') }}</label>
                    <input v-model="transaction.transactionDate" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(operator)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operator') }}</label>
                    <input v-model="operator" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.contact)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.phone') }}</label>
                    <input v-model="transaction.contact" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
              </div>

              <!-- ═══ Onglet 2 : Informations avancées ═══ -->
              <div v-show="activeDetailTab === 'advanced'" v-if="isPrivilegedRole">
                <div class="row g-3">
                  <div class="col-12 col-md-3" v-if="hasValue(transaction.payoutId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.payoutId') }}</label>
                    <input v-model="transaction.payoutId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.bulkId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.bulkId') }}</label>
                    <input v-model="transaction.bulkId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.status)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.technicalStatus') }}</label>
                    <input :value="transaction.status" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.validationStatus)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.validationStatus') }}</label>
                    <input :value="transaction.validationStatus" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.statusCode)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.statusCode') }}</label>
                    <input :value="transaction.statusCode" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.operationType)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operationType') }}</label>
                    <input :value="String(transaction.operationType)==='1' ? $t('transactions.payin') : (String(transaction.operationType)==='2' ? $t('transactions.payout') : transaction.operationType)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.currency)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.currency') }}</label>
                    <input v-model="transaction.currency" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.countryCode)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.countryCode') }}</label>
                    <input v-model="transaction.countryCode" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.totalFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.totalFees') }}</label>
                    <input :value="transaction.totalFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.imoneyFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.imoneyFees') }}</label>
                    <input :value="transaction.imoneyFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.operatorFees)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.operatorFees') }}</label>
                    <input :value="transaction.operatorFees" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.user?.email)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.initiatedByUser') }}</label>
                    <input :value="transaction.user?.email" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.business?.name)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.businessLabel') }}</label>
                    <input :value="transaction.business?.name" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.clientReference)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.clientReference') }}</label>
                    <input v-model="transaction.clientReference" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.clientId)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.clientId') }}</label>
                    <input v-model="transaction.clientId" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.handlingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.handlingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.handlingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.processingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.processingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.processingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.finalStateDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.finalStateDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.finalStateDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.checkingDate)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.checkingDate') }}</label>
                    <input :value="formatDateTimeFr(transaction.checkingDate)" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.apiVersion)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.apiVersion') }}</label>
                    <input v-model="transaction.apiVersion" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>

                  <div class="col-12 col-md-3" v-if="hasValue(transaction.errorMessage)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.errorMessage') }}</label>
                    <input v-model="transaction.errorMessage" type="text" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly style="color: red;" />
                  </div>

                  <div class="col-12" v-if="hasValue(transaction.description)">
                    <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.descriptionLabel') }}</label>
                    <textarea :value="transaction.description" rows="2" class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly></textarea>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Change Status -->
  <div class="modal fade" id="changeStatusModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content edit-status-modal-content">
        <button type="button" class="btn-close status-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>

        <div class="edit-status-header">
          <div class="edit-status-icon">
            <i class="flaticon-pen"></i>
          </div>
          <h5 class="mb-0 mt-10">Modifier le statut</h5>
        </div>

        <div class="modal-body pt-10">
          <div class="edit-status-code-box mb-20">
            <span class="edit-status-code-label">Code transaction</span>
            <span class="edit-status-code-value">{{ changeStatusCheckoutId || '—' }}</span>
          </div>

          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Statut
            </label>
            <select v-model="newStatusValue" class="form-select fs-md-15 text-black shadow-none edit-status-select">
              <option value="OPEN">OPEN</option>
              <option value="COMPLETED">COMPLETED</option>
            </select>
          </div>

          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Statut de paiement
            </label>
            <select v-model="newPaymentStatusValue" class="form-select fs-md-15 text-black shadow-none edit-status-select">
              <option value="SUCCEEDED">SUCCEEDED</option>
              <option value="FAILED">FAILED</option>
              <option value="PENDING">PENDING</option>
              <option value="PROCESSING">PROCESSING</option>
              <option value="INITIATED">INITIATED</option>
              <option value="SCHEDULED">SCHEDULED</option>
            </select>
          </div>

          <!-- Description (facultatif) -->
          <div class="form-group mb-15">
            <label class="d-block text-black fw-semibold mb-10">
              Description <span class="text-muted fw-normal">(facultatif)</span>
            </label>
            <textarea
              v-model="newDescriptionValue"
              class="form-control fs-md-15 text-black shadow-none edit-status-select"
              rows="3"
              placeholder="Ajouter une description…"
            ></textarea>
          </div>

          <!-- State (facultatif, chiffre positif, 1 seul chiffre, max 5) -->
          <div class="form-group mb-5">
            <label class="d-block text-black fw-semibold mb-10">
              State <span class="text-muted fw-normal">(facultatif)</span>
            </label>
            <input
              v-model="newStateValue"
              type="number"
              min="0"
              max="5"
              step="1"
              class="form-control fs-md-15 text-black shadow-none edit-status-select"
              placeholder="0 à 5"
              @input="onStateInput"
            />
            <small v-if="stateError" class="text-danger fs-13">{{ stateError }}</small>
          </div>

          <p v-if="changeStatusError" class="text-danger fs-13 mt-10 mb-0">{{ changeStatusError }}</p>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Annuler</button>
          <button type="button" :disabled="!btnLoadStatus" class="btn edit-status-submit-btn" @click="submitChangeStatus()">
            <span v-if="!btnLoadStatus" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Statut réel de la transaction -->
  <div class="modal fade" id="transactionStatusModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content status-modal-content">
        <button type="button" class="btn-close status-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <div class="modal-body text-center p-0">
          <div v-if="statusLoading" class="status-loading">
            <span class="spinner-grow text-warning" role="status"></span>
            <p class="mt-15 mb-0 text-muted">Vérification en cours...</p>
          </div>
          <div v-else class="status-card">
            <div class="status-icon-wrap" :class="statusIconClass">
              <span v-if="statusDetails.paymentStatus==='SUCCEEDED'"></span>
              <span v-else-if="statusDetails.paymentStatus==='FAILED'"></span>
              <span v-else>⏳</span>
            </div>

            <h5 class="status-title mt-15 mb-5">{{ statusLabelText }}</h5>
            <p class="status-checkout-id mb-20">{{ statusDetails.checkoutId }}</p>

            <div class="status-amount">
              {{ Number(statusDetails.amount || 0).toLocaleString() }} <span>F CFA</span>
            </div>

            <div class="status-badges mt-20">

              <div class="status-item">
                <span class="status-label">Statut</span>
                <span class="status-pill" :class="techStatusClass">
                  {{ statusDetails.status || '—' }}
                </span>
              </div>

              <div class="status-item">
                <span class="status-label">Statut paiement</span>
                <span class="status-pill" :class="paymentStatusClass">
                  {{ translatedPaymentStatus }}
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Generate Link -->
  <div class="modal fade" id="generateLink" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <form @submit.prevent="generateLink">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('transactions.paymentLink') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row g-3">
                <div class="col-md-5" v-if="result!==1"></div>
                <div class="col-6 col-md-3">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.amount') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="ex: 2000" v-model="amount" id="amount" @blur="validate_phone_number($event.target.value,$event.target,12)" @keyup="validate_phone_number($event.target.value,$event.target,12)" />
                  </div>
                </div>
                <div class="col-9 col-md-7" v-if="result==1">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('transactions.link') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" v-model="link" id="link" readonly />
                  </div>
                </div>
                <div class="col-3 col-md-2" style="padding-top: 2%;" v-if="result==1">
                  <label class="d-block text-black fw-semibold mb-10" style="visibility: hidden;">{{ $t('transactions.link') }}</label>
                  <div class="d-flex align-items-center gap-3">
                    <a href="#" class="text-decoration-none" @click.prevent="copyToCliboard">
                      <i class="flaticon-draft fs-6" style="color: #000"></i>
                    </a>
                    <a href="#" class="text-decoration-none" @click.prevent="showQrCodeModal" :title="$t('transactions.showQRCode')">
                      <i class="ph ph-qr-code fs-5" style="color: #000"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0" type="button" @click="reset()">
              <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
              {{ $t('transactions.refresh') }}
            </button>
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_public_token')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('transactions.generatePaymentLink') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal QR Code -->
  <div class="modal fade" id="qrCodeModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('transactions.paymentQRCode') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
          <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="QR Code de paiement" class="qr-code-image mb-15" />
          <p class="text-muted fs-14 mb-0">{{ $t('transactions.scanToPay') }}</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('transactions.close') }}</button>
          <button type="button" class="btn text-white" style="background-color: #EB9355;" @click="downloadQrCode" :disabled="!qrCodeDataUrl">
            {{ $t('transactions.download') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Receipt -->
  <div class="modal fade" id="receiptModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <div id="receipt">
          <div id="header_receipt">
            <h2 style="padding:2% 5% 2% 5%;color: #fff;">
              <span>
                <img src="../../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:10%;"/>
                <span class="logo_text">IZYPAY</span>
              </span>
              <span id="header_text">{{ $t('transactions.transactionReceipt') }}</span>
            </h2>
          </div>
          <div id="body_receipt">
            <div id="arrow-top-section">
              <span id="arrow-top-left" class="section_content"><img src="../../../assets/images/arrowtopleft.svg" alt="logo-icon" style="min-width:3%;"/></span>
              <span id="arrow-top-right" class="section_content"><img src="../../../assets/images/arrowtopright.svg" alt="logo-icon" style="min-width:3%;"/></span>
            </div>
            <div id="body_first_section">
              <p><span class="section_label">{{ $t('transactions.operator') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ operator }}</span></p>
              <p><span class="section_label">{{ $t('transactions.phone') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ transaction.contact }}</span></p>
              <p><span class="section_label">{{ $t('transactions.date') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ formatDateFr(new Date(transaction.transactionDate)) }}</span></p>
              <p style="margin-top: 10%;"><span class="section_label">{{ $t('transactions.transactionCode') }}</span><span class="section_content_other">{{ transaction.checkoutId }}</span></p>
            </div>
            <div id="body_second_section">
              <p><span class="section_label">{{ $t('transactions.amountLabel') }}</span><span class="section_content_other1">{{ amount }} F</span></p>
              <p v-if="transaction.paymentStatus==='FAILED'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.failed') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;"/></span></p>
              <p v-if="transaction.paymentStatus==='SUCCEEDED'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.success') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;"/></span></p>
              <p v-if="transaction.paymentStatus==='PROCESSING'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.processing') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;"/></span></p>
              <p v-if="transaction.paymentStatus==='PENDING'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.pending') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;"/></span></p>
            </div>
            <div id="body_third_section">
              <p><span class="section_label">{{ $t('transactions.thankYou') }}</span>&nbsp;&nbsp;<span class="section_content"><img src="../../../assets/images/imoji.svg" alt="logo-icon" style="max-width:25%;"/></span></p>
            </div>
            <div id="arrow-bottom-section">
              <span id="arrow-bottom-left" class="section_content"><img src="../../../assets/images/arrowbottomleft.svg" alt="logo-icon" style="min-width:3%;"/></span>
              <span id="arrow-bottom-right" class="section_content"><img src="../../../assets/images/arrowbottomright.svg" alt="logo-icon" style="min-width:3%;"/></span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn text-white" style="background-color: #EB9355;" @click="download_receipt()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <i class="flaticon-file-1 position-relative ms-5 fs-12" style="color: #FFF;"></i>
            {{ $t('transactions.download') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div ref="PDFReceipt" id="receipt" class="form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none">
    <div id="header_receipt">
      <h2 style="padding:2% 5% 2% 5%;color: #fff;">
        <span>
          <img src="../../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:10%;" />
          <span class="logo_text">IZYPAY</span>
        </span>
        <span id="header_text">{{ $t('transactions.transactionReceipt') }}</span>
      </h2>
    </div>
    <div id="body_receipt">
      <div id="arrow-top-section">
        <span id="arrow-top-left" class="section_content"><img src="../../../assets/images/arrowtopleft.svg" alt="logo-icon" style="min-width:3%;" /></span>
        <span id="arrow-top-right" class="section_content"><img src="../../../assets/images/arrowtopright.svg" alt="logo-icon" style="min-width:3%;" /></span>
      </div>
      <div id="body_first_section">
        <p v-if="transaction.clientId != ''"><span class="section_label">{{ $t('transactions.beneficiary') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ transaction.clientId }}</span></p>
        <p><span class="section_label">{{ $t('transactions.operator') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ operator }}</span></p>
        <p><span class="section_label">{{ $t('transactions.phone') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ transaction.contact }}</span></p>
        <p><span class="section_label">{{ $t('transactions.date') }}</span>&nbsp;:&nbsp;<span class="section_content">{{ formatDateFr(new Date(transaction.transactionDate)) }}</span></p>
        <p style="margin-top: 10%;"><span class="section_label">{{ $t('transactions.transactionCode') }}</span><span class="section_content_other">{{ transaction.checkoutId }}</span></p>
      </div>
      <div id="body_second_section">
        <p><span class="section_label">{{ $t('transactions.amountLabel') }}</span><span class="section_content_other1">{{ transaction.amount }} F</span></p>
        <p v-if="transaction.paymentStatus === 'FAILED'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.failed') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
        <p v-if="transaction.paymentStatus === 'SUCCEEDED'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.success') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
        <p v-if="transaction.paymentStatus === 'PROCESSING'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.processing') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
        <p v-if="transaction.paymentStatus === 'PENDING'"><span class="section_label">{{ $t('transactions.statusLabel') }}</span><span class="section_content_other1">{{ $t('transactions.pending') }}&nbsp;<img src="../../../assets/images/check.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
      </div>
      <div id="body_third_section">
        <p><span class="section_label">{{ $t('transactions.thankYou') }}</span>&nbsp;&nbsp;<span class="section_content"><img src="../../../assets/images/imoji.svg" alt="logo-icon" style="max-width:25%;" /></span></p>
      </div>
      <div id="arrow-bottom-section">
        <span id="arrow-bottom-left" class="section_content"><img src="../../../assets/images/arrowbottomleft.svg" alt="logo-icon" style="min-width:3%;" /></span>
        <span id="arrow-bottom-right" class="section_content"><img src="../../../assets/images/arrowbottomright.svg" alt="logo-icon" style="min-width:3%;" /></span>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">

import { ref, onMounted, onBeforeUnmount, inject, nextTick, computed } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import { useI18n } from "vue-i18n";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf'
import { Modal } from 'bootstrap';
import QRCode from 'qrcode';

import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import {current_permissions} from '../../../utils/permission';
import { showToast,validate_phone_number,checkSessionValidate } from "@/utils/function";
import {Business,Transaction} from "@/utils/Model";
import stateStore from "../../../utils/store";
const stateStoreInstance = stateStore;
stateStoreInstance.setRole('collecte')
const PDFReceipt = ref<HTMLElement | null>(null);
const backApi=inject('back');
let environment=process.env.VUE_APP_TEST
const { t } = useI18n();
  declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,
  email: string,
  createdAt: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,
  countryCode: string
  }

const leadPlaceholder = "Select date";

let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
let phone_number = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const selectedBusiness = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
let link = ref('');
let qrCodeDataUrl = ref('');
let amount = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const operator = ref('');
const paymentStatus = ref('');
const screenSelected = ref('');
const btnLoad = ref(true);
const btnLoad1 = ref(true);
const errors = ref('');
const errorId = ref('');
let result = ref(0);
const transactions =ref(new Array<Transaction>());
const transaction1s =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);
const business =ref(new Array<Business>());
const subBusiness =ref(new Array<Business>());
let businessTemp =new Array<Business>();
let role: string|null = localStorage.getItem('role');

const isPrivilegedRole = ['SUPERADMIN', 'BUSINESS', 'SUPPORT'].includes(role || '');

const isSuperAdmin = role === 'SUPERADMIN';

const changeStatusCheckoutId = ref('');
const newStatusValue = ref('');
const newPaymentStatusValue = ref('');
const btnLoadStatus = ref(true);
const changeStatusError = ref('');

const newDescriptionValue = ref('');
const newStateValue = ref('');
const stateError = ref('');

const statusDetails = ref<any>({});
const statusLoading = ref(false);
let statusModalListenerAttached = false;

const filterCode = ref('');
const filterCheckoutId = ref('');
const filterPayoutId = ref('');
const filterClientReference = ref('');
const filterClientId = ref('');
const filterDescription = ref('');
const filterPublicToken = ref('');
const filterState = ref('');
const filterAmount = ref('');
const filterMaxAmount = ref('');
const filterMinAmount = ref('');
const filterIntBulkId = ref('');
const filterIntOperatorBulkId = ref('');
const filterBulkId = ref('');
const filterOperationType = ref('');
const filterTransactionDate = ref('');
const filterUser = ref('');
const filterPayoutType = ref('');
const filterValidationStatus = ref('');
const filterPublicTokenValidationStatus = ref('');

// ═══ Onglets actifs ═══
const activeFilterTab = ref<'base' | 'advanced'>('base');
const activeDetailTab = ref<'main' | 'advanced'>('main');

const isFilled = (v: any) => v !== '' && v !== null && v !== undefined;

const activeBaseFiltersCount = computed(() => {
  return [
    selectedOrganization.value,
    selectedOperator.value,
    selectedStatus.value,
    selectedBusiness.value,
    phone_number.value,
  ].filter(isFilled).length;
});

const activeAdvancedFiltersCount = computed(() => {
  return [
    filterCode.value, filterCheckoutId.value, filterPayoutId.value,
    filterClientReference.value, filterClientId.value, filterDescription.value,
    filterPublicToken.value, filterState.value, filterAmount.value,
    filterMinAmount.value, filterMaxAmount.value, filterIntBulkId.value,
    filterIntOperatorBulkId.value, filterBulkId.value, filterOperationType.value,
    filterTransactionDate.value, filterUser.value, filterPayoutType.value,
    filterValidationStatus.value, filterPublicTokenValidationStatus.value,
  ].filter(isFilled).length;
});

const onStateInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let val = input.value;

  val = val.replace(/[^0-9]/g, '');

  if (val.length > 1) {
    val = val.slice(0, 1);
  }

  if (val !== '' && parseInt(val, 10) > 5) {
    val = '5';
  }

  newStateValue.value = val;
  input.value = val;

  if (val === '') {
    stateError.value = '';
  } else if (parseInt(val, 10) > 5) {
    stateError.value = 'La valeur ne peut pas dépasser 5.';
  } else {
    stateError.value = '';
  }
};

let url = '';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();
        day = day<10?'0'+day:day;
        return day+'/'+month+'/'+year;

    }
}

function formatDateTimeFr(value: string | null | undefined){
    if(!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2,'0');
    const month = String(d.getMonth()+1).padStart(2,'0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2,'0');
    const minutes = String(d.getMinutes()).padStart(2,'0');
    const seconds = String(d.getSeconds()).padStart(2,'0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function hasValue(value: any): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === '—' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  if (typeof value === 'number' && isNaN(value)) return false;
  return true;
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;
        day = day<10?'0'+day:day;
        return year+'-'+month+'-'+day;

    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;
        day = day<10?'0'+day:day;
        return year+'-'+month+'-'+day;

    }
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){
      if(operatorsTemp[j].countryCode == event.target.value){
          operatorArr.push(operatorsTemp[j]);
      }
      j++;
  }
   operators.value = operatorArr;
}

function handleFilterOperationTypeChange(event) {
  filterOperationType.value = event.target.value;
}

function handleFilterPayoutTypeChange(event) {
  filterPayoutType.value = event.target.value;
}

function handleFilterValidationStatusChange(event) {
  filterValidationStatus.value = event.target.value;
}

function handleFilterPublicTokenValidationStatusChange(event) {
  filterPublicTokenValidationStatus.value = event.target.value;
}

function buildFilterQuery(): string {
  const params = new URLSearchParams();

  if (filterCode.value) params.append('code', filterCode.value);
  if (filterCheckoutId.value) params.append('checkoutId', filterCheckoutId.value);
  if (filterPayoutId.value) params.append('payoutId', filterPayoutId.value);
  if (filterClientReference.value) params.append('clientReference', filterClientReference.value);
  if (filterClientId.value) params.append('clientId', filterClientId.value);
  if (filterDescription.value) params.append('description', filterDescription.value);
  if (filterPublicToken.value) params.append('publicToken', filterPublicToken.value);
  if (filterState.value) params.append('state', filterState.value);
  if (filterAmount.value !== '' && filterAmount.value !== null) params.append('amount', String(filterAmount.value));
  if (filterMaxAmount.value !== '' && filterMaxAmount.value !== null) params.append('maxAmount', String(filterMaxAmount.value));
  if (filterMinAmount.value !== '' && filterMinAmount.value !== null) params.append('minAmount', String(filterMinAmount.value));
  if (filterIntBulkId.value) params.append('intBulkId', filterIntBulkId.value);
  if (filterIntOperatorBulkId.value) params.append('intOperatorBulkId', filterIntOperatorBulkId.value);
  if (filterBulkId.value) params.append('bulkId', filterBulkId.value);
  if (filterTransactionDate.value) params.append('transactionDate', filterTransactionDate.value);
  if (filterUser.value) params.append('user', filterUser.value);
  if (filterPayoutType.value) params.append('payoutType', filterPayoutType.value);
  if (filterValidationStatus.value) params.append('validationStatus', filterValidationStatus.value);
  if (filterPublicTokenValidationStatus.value) params.append('publicTokenValidationStatus', filterPublicTokenValidationStatus.value);

  return params.toString();
}

function resolveOperationType(): string {
  return filterOperationType.value ? filterOperationType.value : process.env.VUE_APP_PAYIN_OPTTYPE;
}

function resetAdvancedFilters() {
  filterCode.value = '';
  filterCheckoutId.value = '';
  filterPayoutId.value = '';
  filterClientReference.value = '';
  filterClientId.value = '';
  filterDescription.value = '';
  filterPublicToken.value = '';
  filterState.value = '';
  filterAmount.value = '';
  filterMaxAmount.value = '';
  filterMinAmount.value = '';
  filterIntBulkId.value = '';
  filterIntOperatorBulkId.value = '';
  filterBulkId.value = '';
  filterOperationType.value = '';
  filterTransactionDate.value = '';
  filterUser.value = '';
  filterPayoutType.value = '';
  filterValidationStatus.value = '';
  filterPublicTokenValidationStatus.value = '';

  const opType = document.getElementById('filterOperationType') as HTMLSelectElement | null;
  if (opType) opType.value = '';
  const payoutType = document.getElementById('filterPayoutType') as HTMLSelectElement | null;
  if (payoutType) payoutType.value = '';
  const validationStatusEl = document.getElementById('filterValidationStatus') as HTMLSelectElement | null;
  if (validationStatusEl) validationStatusEl.value = '';
  const publicTokenValidationStatusEl = document.getElementById('filterPublicTokenValidationStatus') as HTMLSelectElement | null;
  if (publicTokenValidationStatusEl) publicTokenValidationStatusEl.value = '';
}

function reset(){
  amount.value = 0;
  link.value = '';
  result.value=0;
  qrCodeDataUrl.value = '';
  const qrModalEl = document.getElementById('qrCodeModal');
  if (qrModalEl) {
    Modal.getInstance(qrModalEl)?.hide();
  }
}

function copyToCliboard() {
  const copyText = document.getElementById("link") as HTMLInputElement | null;
  if (!copyText) return;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié","green");
}

async function showQrCodeModal() {
  if (!link.value) {
    showToast("Générez d'abord un lien de paiement", "red");
    return;
  }

  try {
    qrCodeDataUrl.value = await QRCode.toDataURL(link.value, {
      width: 250,
      margin: 2,
    });

    const qrModalEl = document.getElementById('qrCodeModal');
    if (qrModalEl) {
      Modal.getOrCreateInstance(qrModalEl).show();
    }
  } catch {
    showToast("Erreur lors de la génération du QR code", "red");
  }
}

function downloadQrCode() {
  if (!qrCodeDataUrl.value) return;

  const anchor = document.createElement('a');
  anchor.href = qrCodeDataUrl.value;
  anchor.download = 'qrcode-paiement.png';
  anchor.click();
}

const generateLink = ()=>{

try {
  axios.post(`${backApi}/secure/transactions/token`,{
          amount:amount.value==0?null:amount.value,
          operationType:process.env.VUE_APP_PAYIN_OPTTYPE,
        }, {
      headers: {
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }
      }).then((response) => {
        if(response.status === 201){
          link.value =  response.data.ticketUrl
          result.value=1;
        }

    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')

              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }

          }
  });
} catch (error) {
         errors.value="une erreur inattendue est apparue"

}

}

const openMenuId = ref<string | null>(null);
const menuPosition = ref({ top: 0, left: 0 });
let menuOpenedAt = 0;

function toggleActionMenu(event: MouseEvent, checkoutId: string) {
  if (openMenuId.value === checkoutId) {
    closeActionMenu();
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();
  const menuWidth = 220;

  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  if (left + menuWidth > window.innerWidth - 8) {
    left = window.innerWidth - menuWidth - 8;
  }

  menuPosition.value = { top: rect.bottom + 4, left };
  openMenuId.value = checkoutId;
  menuOpenedAt = Date.now();

  nextTick(() => {
    const menuEl = document.querySelector('.action-menu-fixed') as HTMLElement | null;
    if (!menuEl) return;
    const menuHeight = menuEl.offsetHeight;

    let top = rect.bottom + 4;
    if (top + menuHeight > window.innerHeight - 8) {
      top = rect.top - menuHeight - 4;
    }
    if (top < 8) top = 8;

    menuPosition.value = { ...menuPosition.value, top };
  });
}

function closeActionMenu() {
  openMenuId.value = null;
}

function findTransactionInList(checkoutId: string) {
  return transactions.value.find((t) => t.checkoutId === checkoutId)
      || transaction1s.value.find((t) => t.checkoutId === checkoutId);
}

function setTransactionData(data) {
  transaction.value = data;
  operator.value = data.operator?.mnoName ?? '';
  amount.value = data.amount != null ? data.amount.toLocaleString() : 0;

  if (data.paymentStatus === 'SUCCEEDED') {
    paymentStatus.value = "SUCCESS";
  } else if (data.paymentStatus === 'PROCESSING') {
    paymentStatus.value = "EN COURS";
  } else if (data.paymentStatus === 'PENDING') {
    paymentStatus.value = "EN ATTENTE";
  } else {
    paymentStatus.value = "ECHEC";
  }

  loader.value = true;
}

function handleView(checkoutId: string) {
  const found = findTransactionInList(checkoutId);
  if (found) {
    setTransactionData(found);
  } else {
    loadTransaction(checkoutId);
  }
  closeActionMenu();

  // Réinitialiser sur l'onglet principal
  activeDetailTab.value = 'main';

  const modalEl = document.getElementById('companyModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleReceipt(checkoutId: string) {
  const found = findTransactionInList(checkoutId);
  if (found) {
    setTransactionData(found);
  } else {
    loadTransaction(checkoutId);
  }
  closeActionMenu();
  const modalEl = document.getElementById('receiptModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleChangeStatus(checkoutId: string) {
  const found = findTransactionInList(checkoutId);

  changeStatusCheckoutId.value = found?.code ?? checkoutId;

  newStatusValue.value = found?.status ?? '';
  newPaymentStatusValue.value = found?.paymentStatus ?? '';

  newDescriptionValue.value = (found as any)?.description ?? '';
  newStateValue.value = (found as any)?.state != null ? String((found as any).state) : '';
  stateError.value = '';

  changeStatusError.value = '';
  closeActionMenu();

  const modalEl = document.getElementById('changeStatusModal');
  if (modalEl) {
    Modal.getOrCreateInstance(modalEl).show();
  }
}

function submitChangeStatus() {
  changeStatusError.value = '';

  if (!changeStatusCheckoutId.value) {
    changeStatusError.value = "Le code de la transaction est requis.";
    return;
  }

  const payload: any = { code: changeStatusCheckoutId.value };
  if (newStatusValue.value) payload.status = newStatusValue.value;
  if (newPaymentStatusValue.value) payload.paymentStatus = newPaymentStatusValue.value;

  if (newDescriptionValue.value && newDescriptionValue.value.trim() !== '') {
    payload.description = newDescriptionValue.value.trim();
  }
  if (newStateValue.value !== '' && newStateValue.value !== null) {
    payload.state = parseInt(newStateValue.value, 10);
  }

  btnLoadStatus.value = false;

  axios.post(`${backApi}/secure/transactions/status`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadStatus.value = true;
    showToast("Statut mis à jour", "green");
    const modalEl = document.getElementById('changeStatusModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();

    if (search.value) {
      searchTransaction(page.value);
    } else if (search1.value) {
      searchTransaction1({ target: {} }, page.value);
    } else {
      getTransactions(page.value);
    }
  }).catch((error) => {
    btnLoadStatus.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
        showToast(error.response.data.message, "red");
      }
    }
  });
}

function handleShowStatus(checkoutId: string) {
  closeActionMenu();
  statusLoading.value = true;
  statusDetails.value = {};

  const modalEl = document.getElementById('transactionStatusModal');
  if (!modalEl) return;

  const modalInstance = Modal.getOrCreateInstance(modalEl);

  if (!statusModalListenerAttached) {
    modalEl.addEventListener('hidden.bs.modal', handleStatusModalClosed);
    statusModalListenerAttached = true;
  }

  modalInstance.show();

  axios.get(`${backApi}/secure/transactions/${checkoutId}/status`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    statusDetails.value = response.data;
    statusLoading.value = false;
  }).catch((error) => {
    statusLoading.value = false;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        showToast(error.response?.data?.message ?? "Erreur lors de la récupération du statut", "red");
      }
    }
  });
}

function handleStatusModalClosed() {
  if (search.value) {
    searchTransaction(page.value);
  } else if (search1.value) {
    searchTransaction1({ target: {} }, page.value);
  } else {
    getTransactions(page.value);
  }
}

const translatedPaymentStatus = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return t('transactions.success');
    case 'FAILED': return t('transactions.failed');
    case 'PROCESSING': return t('transactions.processing');
    case 'PENDING': return t('transactions.pending');
    default: return statusDetails.value.paymentStatus || '—';
  }
});

const statusIconClass = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'status-icon-success';
    case 'FAILED': return 'status-icon-failed';
    default: return 'status-icon-pending';
  }
});

const statusLabelText = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'Transaction réussie';
    case 'FAILED': return 'Transaction échouée';
    case 'PROCESSING': return 'Transaction en cours';
    case 'PENDING': return 'Transaction en attente';
    default: return 'Statut inconnu';
  }
});

const techStatusClass = computed(() => statusDetails.value.status === 'COMPLETED' ? 'pill-completed' : 'pill-open');

const paymentStatusClass = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'pill-success';
    case 'FAILED': return 'pill-failed';
    default: return 'pill-pending';
  }
});

const paymentStatusLabel = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return "Le paiement a été effectué avec succès.";
    case 'FAILED': return "Le paiement a échoué, aucun montant n'a été débité/reçu.";
    case 'PENDING': return "Le paiement est en attente de confirmation.";
    case 'PROCESSING': return "Le paiement est en cours de traitement par l'opérateur.";
    default: return "Statut de paiement non déterminé.";
  }
});

function handleGlobalClick(e: MouseEvent) {
  if (!openMenuId.value) return;
  const target = e.target as HTMLElement;
  if (target.closest('.action-menu-fixed') || target.closest('.dropdown-toggle')) {
    return;
  }
  closeActionMenu();
}

function handleGlobalScroll() {
  if (!openMenuId.value) return;
  if (Date.now() - menuOpenedAt < 300) return;
  closeActionMenu();
}

onMounted(() => {
  checkSessionValidate(1)

  getTransactions();
  getOrganizations();
  getOperators();
  getBusiness();

  setTimeout(function () {
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
      flatpickr("#lead-calendar-transactionDate", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('scroll', handleGlobalScroll, true);
});

onBeforeUnmount(() => {
  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.removeEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('scroll', handleGlobalScroll, true);
});

const token =  localStorage.getItem('login_token');
const codeOrganization =  localStorage.getItem('organization_code');
const organization_name =  localStorage.getItem('organization_name');
const email =  localStorage.getItem('email');

const loadTransaction = (code)=>{

  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        setTransactionData(response.data);
    }).catch((error) => {
      loader.value=true;
      console.error('loadTransaction error:', error);
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}

const getTransactions = (arg=1) =>{


    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    const todayB =  formatDateEn(new Date());
    const todayE =  formatDateEn(new Date(),1);
    axios.get(`${url}?page=${arg}&dateD=${todayB}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('getTransactions response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);

        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        organizations.value = response.data.sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
        console.log(organizations.value);


    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
              }

          }
   });
}

const getOperators = () =>{
axios.get(backApi+'/secure/operators/available/'+process.env.VUE_APP_PAYIN_OPTTYPE,{
  headers: {

        Authorization: `Bearer ${token}`
  }
})
.then((response) => {
    operatorsTemp = response.data;

    operators.value = response.data;

    console.log(response.data);


}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')

          }

      }
});
}

const exportExcelReport = (labels,fields,filename) =>{

  import("../../../utils/Export2Excel").then((excel)=>{

    const dataForExcel= formatJSon(fields,data);
    excel.export_json_to_excel({
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcelReportOld = () =>{

  import("../../../utils/Export2Excel").then((excel)=>{
    const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
    const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];
    const dataForExcel= formatJSon(Fields,data);
    excel.export_json_to_excel({
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"report",
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcel = () =>{

  import("../../../utils/Export2Excel").then((excel)=>{
    const Header =["CODE TRANSACTION","OPERATEUR","DESCRIPTION","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["checkoutId","operator_name","description","contact","amount","transactionDate","paymentStatus"];
    const dataForExcel= formatJSon(Fields,data);
    excel.export_json_to_excel({
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportToPDF = () =>{
  searchTransactionExportToPDF()

  setTimeout(() => {

        document.getElementById("transactionsTable").style.display='block';
        const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  },image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },}

      html2pdf().set(opt).from(document.getElementById("transactionsTable")).toPdf().get('pdf').then(function (pdf) {

      window.open(pdf.output('bloburl'), '_blank');
      document.getElementById("transactionsTable").style.display='none';
      });

    }, 3000);


}

const searchTransactionExportToPDF = ()=>{
   btnLoad1.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }

    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {

        if(response.status === 200){
           transaction1s.value  = response.data;
           btnLoad1.value=true;
        }
    }).catch((error) => {
      btnLoad1.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('searchTransaction response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}
const searchTransaction1 = (event,arg=1)=>{
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value
   }

    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);
  axios.get(`${url}?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('searchTransaction1 response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}

const searchTransactionForExport = ()=>{
   btnLoad.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }

    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        if(response.status === 200){
        data  = response.data;

        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
        }

        exportExcel()
        btnLoad.value=true;
      }
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

const reportForExport = ()=>{
   btnLoad.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);
  axios.post(`${backApi}/secure/organizations/report`,
       {
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        if(response.status === 200){
        data  = response.data.transactions;
        console.log(data)

        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));
        }

        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report");
        btnLoad.value=true;
      }
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

const showScreen = (screen)=>{
  screenSelected.value=screen
  selectedBusiness.value='';
  selectedOperator.value='';
  selectedStatus.value='';

  // Réinitialiser sur l'onglet principal
  activeFilterTab.value = 'base';

  const element = document.querySelector('input');
  const event = new KeyboardEvent('keydown', {'key': '65'});
  element.dispatchEvent(event);
}

const getBusiness = (arg=1) =>{
    let param = '';
    param = `?organization=${codeOrganization}`
    axios.get(backApi+'/secure/business/'+param,{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        data  = response.data;
        businessTemp = response.data;
        getBusinessParent(businessTemp)

    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')

              }

          }
  });
}

const getBusinessParent = (businessParents) =>{
  var j = 0;
  var businessArr = new Array<Business>();
  while(j<businessParents.length){
      if(businessParents[j].parent == null){
        businessArr.push(businessParents[j]);
      }
      j++;
  }
  business.value = businessArr;
}

function handleBusinessChange(event) {
      selectedBusiness.value = event.target.value;
      subBusiness.value = [];
      var j = 0;
      var businessArr = new Array<Business>();
      while(j<businessTemp.length){
          if(businessTemp[j].parent?.code == event.target.value){
            businessArr.push(businessTemp[j]);
          }
          j++;
      }

      if(businessArr.length>0){
        subBusiness.value = businessArr;
        document.getElementById("container_sub_business").style.display='block';
        document.getElementById("sub_business1").style.display='block';

      }else{
        document.getElementById("container_sub_business").style.display='none';
        document.getElementById("sub_business1").style.display='none';
      }

}

function handleSubBusinessChange(event) {
      selectedBusiness.value = event.target.value;
}

const download_receipt = (payoutId) => {
  var event;
  loadTransaction(payoutId)

  const element = PDFReceipt.value;
  element.classList.remove("d-none");


  document.getElementById("back").classList.add("d-none");
  setTimeout(() => {


    document.getElementById("receipt").style.display = 'block';

    const opt = {
      margin: [0, 0, 0, 0], filename: "receipt_" + transaction.value.payoutId + ".pdf", jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }, image: { type: 'jpeg', quality: 0.98 },

      html2canvas: { scale: 2 },
    }
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save()

  }, 3000);
  setTimeout(() => {
    element.classList.add("d-none");
    document.getElementById("back").classList.remove("d-none");
  }, 3000);
}
</script>
<style scoped>
#title{
 text-decoration: underline;
 border-bottom: 1px solid #861727;
}
#subtitle{
 margin-bottom: 5%;
}
#headerRightText{
 padding-right: 2%;
 width:50%;
float:right;
font-weight: bold;
}
#headerLeftText{
 padding-right: 2%;
 width:50%;
float:left;
font-weight: bold;
}
#transactionsTable{
 display: none;
 margin-right:5%;
 margin-left:5%;
}
.tableHeader{

  font-size: 15px;
  padding-top:-2px ;
  font-weight: bold;
  background-color: #EC9B59;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  color: #fff;
}
.tableHeader1{
  font-size: 15px;
  padding: auto;
  font-weight: bold;
  background-color: #EC9B59;
  border-right: 1px solid #EC9B59;
  border-top-right-radius: 90px;
  border-bottom: 1px solid #fff;
  color: #fff;
}
hr {
  border-top: 2px solid #fff;
  width:100%;
  margin-top: 5%;
}
#tableLayout{
}

#tableLayout td,#tableLayout th{
   font-size: 12px;
}

#tableLayout td{
  border-bottom: 0.5px solid #861727;

}
#sub_business1,#container_sub_business{
  display: none;
}
.redcolor{
  color: #861727;
}

#title1{
  display: inline-block;
  background-color: #861727;
  color: #fff;
  font-size: 50%;
  border: 1px solid #861727;
  border-radius: 5px 5px 5px 0px;
  padding: 5px 10px 5px 10px;
}
#title2{
font-size: 50%;
display: inline-block;
margin-left: 25%;
}
.date{
font-weight: bold;
}
#t-thead-pdf{
  background-color: #EC9B59;
  border:  1px solid #EC9B59;
}
#receipt{
  margin-top: 5px;
}
#header_receipt{
  margin-top: -1%;
  background-color: #871728;
}
#logo_text{
  font-family: Gruppo;
}
#header_text{
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
}
#arrow-top-left{
  margin-left:7%
}
#arrow-top-right{
  margin-left:80%
}
#arrow-bottom-left{
  margin-left:7%
}
#arrow-bottom-right{
  margin-left:80%
}

#changeStatusModal .modal-dialog {
  max-width: 400px;
  width: 90%;
}

#changeStatusModal .modal-content {
  border-radius: 12px;
}

#body_receipt{
  display: flex;
  flex-direction: column;
  padding-top: 15%;
  padding-bottom: 15%;
}
#body_first_section{
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_second_section{
  margin-top:5%;
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
.status-badges {
  display: flex;
  justify-content: center;
  gap: 25px;
}

.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.status-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
}
#body_third_section{
  margin-top:5%;
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
.section_label{
  font-size: 100%;
  font-weight: bold;
}
.section_content_other{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 7%;
  padding: 5px 15px 5px 15px;
}
.section_content_other1{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.PDFReceipt.d-none {
  display: block !important;
  visibility: hidden;
}

#receipt {
  margin-top: 5px;
   border: 1px solid #706F6F;
  border-bottom: 1px solid #FFF;
  display: flex;
  flex-direction: column;
  width: 148mm;
}

#header_receipt {
  margin-top: -1%;
  background-color: #871728;
}

#logo_text {
  font-family: gruppo;
}

#header_text {
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
}

#arrow-top-left {
  margin-left: 12%
}

#arrow-top-right {
  margin-left: 70%
}

#arrow-bottom-left {
  margin-left: 12%
}

#arrow-bottom-right {
  margin-left: 70%
}

#body_receipt {
  display: flex;
  flex-direction: column;
  padding-top: 15%;
  width: 100%;
}

#body_first_section {
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_second_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_third_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.section_label {
  font-size: 100%;
  font-weight: bold;
}

.section_content_other {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 1%;
  padding: 5px 15px 5px 15px;
}

.section_content_other1 {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.qr-code-image {
  max-width: 100%;
  height: auto;
}

.modal-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

.modal-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: #777;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: color .15s ease, border-color .15s ease;
  font-family: inherit;
  white-space: nowrap;
}

.modal-tab:hover:not(.active) {
  color: #EB9355;
}

.modal-tab.active {
  color: #EB9355;
  border-bottom-color: #EB9355;
}

.tab-badge {
  background: #282523;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 10px;
  padding: 0 6px;
}

.modal-tab.active .tab-badge {
  background: #EB9355;
}

#filterLeadModal .modal-body,
#companyModal .modal-body {
  max-height: 75vh;
  overflow-y: auto;
}

.status-modal-content {
  border-radius: 18px;
  border: none;
  overflow: hidden;
  padding-top: 10px;
  position: relative;
}
.status-modal-close {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 5;
}
.status-loading {
  padding: 50px 20px;
}
.status-card {
  padding: 35px 25px 20px 25px;
}
.status-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
}
.status-icon-success {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  box-shadow: 0 8px 20px rgba(39, 174, 96, .35);
}
.status-icon-failed {
  background: linear-gradient(135deg, #ff6b6b, #e74c3c);
  box-shadow: 0 8px 20px rgba(231, 76, 60, .35);
}
.status-icon-pending {
  background: linear-gradient(135deg, #f7b733, #EB9355);
  box-shadow: 0 8px 20px rgba(235, 147, 85, .35);
}
.status-title {
  font-weight: 700;
  color: #222;
}
.status-checkout-id {
  font-size: 13px;
  color: #999;
  letter-spacing: .3px;
}
.status-amount {
  font-size: 34px;
  font-weight: 800;
  color: #861727;
}
.status-amount span {
  font-size: 14px;
  font-weight: 600;
  color: #999;
  margin-left: 4px;
}
.status-badges {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}
.status-pill {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .5px;
  text-transform: uppercase;
}
.pill-completed { background: #e8f8ee; color: #27ae60; }
.pill-open { background: #fff4e5; color: #EB9355; }
.pill-success { background: #e8f8ee; color: #27ae60; }
.pill-failed { background: #fdecea; color: #e74c3c; }
.pill-pending { background: #fff4e5; color: #EB9355; }

/* Libellés explicatifs dans le modal "Statut réel" */
.status-explain {
  text-align: left;
  border-top: 1px dashed #eee;
  padding-top: 18px;
}
.status-explain-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}
.status-explain-row:last-child {
  margin-bottom: 0;
}
.status-explain-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}
.status-explain-dot.pill-completed,
.status-explain-dot.pill-success { background: #27ae60; }
.status-explain-dot.pill-open,
.status-explain-dot.pill-pending { background: #EB9355; }
.status-explain-dot.pill-failed { background: #e74c3c; }
.status-explain-text {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
}
.status-explain-text strong {
  font-size: 12.5px;
  color: #222;
  letter-spacing: .3px;
}
.status-explain-text span {
  font-size: 12.5px;
  color: #777;
}

.edit-status-modal-content {
  border-radius: 18px;
  border: none;
  overflow: hidden;
  position: relative;
}
.edit-status-header {
  text-align: center;
  padding: 30px 25px 15px 25px;
  background: linear-gradient(135deg, #fff6ee, #ffffff);
}
.edit-status-icon {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: linear-gradient(135deg, #f7b733, #EB9355);
  color: #fff;
  font-size: 22px;
  box-shadow: 0 8px 18px rgba(235, 147, 85, .35);
}
.edit-status-header h5 {
  font-weight: 700;
  color: #222;
}
.edit-status-subtitle {
  font-size: 13px;
  color: #999;
}
.edit-status-code-box {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #faf7f5;
  border: 1px solid #f0e6de;
  border-radius: 12px;
  padding: 12px 16px;
}
.edit-status-code-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: #b98a63;
  font-weight: 700;
}
.edit-status-code-value {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  word-break: break-all;
}
.edit-status-select {
  border-radius: 10px;
}
.edit-status-submit-btn {
  background-color: #EB9355;
  border-radius: 10px;
  padding: 8px 22px;
}
.edit-status-submit-btn:hover {
    background-color: #3d7e24;
    border-color: #f5b800;
    color: #fff;
}

@media (max-width: 767px) {
  .table-responsive table {
    font-size: 13px;
  }
  .card-head button {
    width: 100%;
    justify-content: center;
  }
  .pagination-area {
    flex-direction: column;
    gap: 10px;
  }
}

@media (max-width: 576px) {
  .modal-tab {
    padding: 12px 10px;
    font-size: 13px;
  }
}

@media (min-width: 992px) {
  .w-lg-30 {
    width: 30% !important;
  }
}
</style>

<style>
.action-menu-fixed {
  position: fixed;
  z-index: 2000;
  min-width: 200px;
  max-width: calc(100vw - 20px);
  max-height: calc(100vh - 20px);
  overflow-y: auto;
  display: block;
  pointer-events: auto;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 6px 0;
}
</style>